export const iconFontAwesomeUsersPeoplePersonPregnant = (
	<i className="fa-solid fa-person-pregnant"></i>
);
